import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className={styles.footer}>
            <div className="container">
                <div className={styles.footerContent}>
                    <div className={styles.footerSection}>
                        <h4 className={styles.footerTitle}>Racine Technique</h4>
                        <p className={styles.footerText}>
                            Création de sites web performants, rapides et responsables.
                        </p>
                        <div className={styles.ecoBadge}>
                            <svg width="20" height="20" viewBox="0 0 48 48" fill="none" style={{ marginRight: '8px' }}>
                                <path d="M24 6C24 6 12 16 12 30C12 38 18 42 24 42C30 42 36 38 36 30C36 16 24 6 24 6Z" stroke="url(#footerEcoGrad)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M24 6V42" stroke="url(#footerEcoGrad)" strokeWidth="3" strokeLinecap="round" />
                                <path d="M24 30L32 22" stroke="url(#footerEcoGrad)" strokeWidth="3" strokeLinecap="round" />
                                <path d="M24 22L16 14" stroke="url(#footerEcoGrad)" strokeWidth="3" strokeLinecap="round" />
                                <defs>
                                    <linearGradient id="footerEcoGrad" x1="12" y1="6" x2="36" y2="42" gradientUnits="userSpaceOnUse">
                                        <stop stopColor="#00ff9d" />
                                        <stop offset="1" stopColor="#2e8b57" />
                                    </linearGradient>
                                </defs>
                            </svg>
                            Hébergement écologique
                        </div>
                    </div>

                    <div className={styles.footerSection}>
                        <h4 className={styles.footerTitle}>Navigation</h4>
                        <ul className={styles.footerLinks}>
                            <li><a href="#accueil">Accueil</a></li>
                            <li><a href="#services">Services</a></li>
                            <li><a href="#portfolio">Réalisations</a></li>
                            <li><a href="#about">À propos</a></li>
                            <li><a href="#contact">Contact</a></li>
                        </ul>
                    </div>

                    <div className={styles.footerSection}>
                        <h4 className={styles.footerTitle}>Services</h4>
                        <ul className={styles.footerLinks}>
                            <li><a href="#services">Création de sites</a></li>
                            <li><a href="#services">Refonte & Optimisation</a></li>
                            <li><a href="#services">SEO & Marketing</a></li>
                            <li><a href="#services">Maintenance</a></li>
                        </ul>
                    </div>

                    <div className={styles.footerSection}>
                        <h4 className={styles.footerTitle}>Réseaux sociaux</h4>
                        <div className={styles.socialLinks}>
                            <a href="#" aria-label="LinkedIn">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ marginRight: '8px' }}>
                                    <rect x="2" y="2" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none" />
                                    <path d="M6 8V14M10 8V14M10 11C10 11 10 8 13 8C15 8 15 10 15 11V14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                                    <circle cx="6" cy="5" r="1" fill="currentColor" />
                                </svg>
                                LinkedIn
                            </a>
                            <a href="#" aria-label="Twitter">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ marginRight: '8px' }}>
                                    <path d="M3 3L8 10L3 17M8 3L13 10L8 17M13 3L18 10L13 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none" />
                                </svg>
                                Twitter
                            </a>
                            <a href="#" aria-label="GitHub">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ marginRight: '8px' }}>
                                    <circle cx="10" cy="10" r="7" stroke="currentColor" strokeWidth="1.5" fill="none" />
                                    <path d="M10 3V10M10 10L14 14M10 10L6 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                                </svg>
                                GitHub
                            </a>
                        </div>
                    </div>
                </div>

                <div className={styles.footerBottom}>
                    <div className={styles.footerLegal}>
                        <Link to="/mentions-legales">Mentions légales</Link>
                        <span>|</span>
                        <Link to="/cgv">CGV</Link>
                        <span>|</span>
                        <a href="#">Politique de confidentialité</a>
                    </div>

                    <p className={styles.copyright}>
                        © {currentYear} Racine Technique. Tous droits réservés.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
